import cloneDeep from 'lodash/cloneDeep.js';
import { ALL_THEMES, fontMap, } from './constants/index.js';
import { mergeBorderRadii } from './mergeBorderRadii.js';
import { mergeColors } from './mergeColors.js';
export const computeMergedTheme = (brandTheme) => {
    const { baseTheme: theme, overrides, palette } = brandTheme;
    const { config } = cloneDeep(ALL_THEMES[theme]);
    const basePairing = fontMap[theme][overrides?.font?.pairing ?? config.font.pairing];
    return {
        borderRadius: mergeBorderRadii(config.borderRadius, overrides?.borderRadius ?? {}),
        colors: mergeColors(config.colors, overrides?.colors ?? {}, palette),
        font: overrides?.font?.customFontUrl
            ? {
                primary: overrides.font.customFontName ?? basePairing.primary,
                secondary: basePairing.secondary,
                customFontUrl: overrides.font.customFontUrl,
                customFontName: overrides.font.customFontName,
                customFontStatus: overrides.font.customFontStatus,
            }
            : basePairing,
        palette,
        theme,
    };
};
//# sourceMappingURL=computeMergedTheme.js.map